import styled from 'styled-components';

import { BoutiqueCard } from '../BoutiqueCard';

export const BoutiqueCardStyled = styled(BoutiqueCard)`
  height: 100%;
`;
